const DEFAULT_LEGISLATION_CAPABILITIES = Object.freeze({
    exemptions: false,
})

const LEGISLATION_CAPABILITY_REGISTRY = Object.freeze({
    rohs: Object.freeze({
        exemptions: true,
    }),
})

const normalizeLegislationKey = value => (
    typeof value === 'string' ? value.trim().toLowerCase() : ''
)

const resolveLegislationCapabilities = (legislation = {}) => {
    const key = normalizeLegislationKey(legislation.key)
    const fallback = LEGISLATION_CAPABILITY_REGISTRY[key]
        || DEFAULT_LEGISLATION_CAPABILITIES
    const supplied = legislation.capabilities && typeof legislation.capabilities === 'object'
        ? legislation.capabilities
        : {}

    return Object.freeze({
        exemptions: typeof supplied.exemptions === 'boolean'
            ? supplied.exemptions
            : fallback.exemptions,
    })
}

export {
    DEFAULT_LEGISLATION_CAPABILITIES,
    LEGISLATION_CAPABILITY_REGISTRY,
    resolveLegislationCapabilities,
}
